export const basicClass = (
    wd: string,
    bg: string,
    cl: string,
    bd: string
): object => {
    const basicClass = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px 20px',
        gap: '10px',
        width: !wd ? 'auto' : wd,
        height: '50px',
        background: bg,
        borderRadius: '6px',
        flex: 'none',
        order: '0',
        alignSelf: 'stretch',
        flexGrow: '1',
        fontSize: '13px',
        color: cl,
        border: bd,
        textTransform: 'inherit',
        ':hover': {
            bgcolor: bg,
            boxShadow: 'none',
        },
        boxShadow: 'none',
    };

    return basicClass;
};
